// The content positions itself; recharts' wrapper is pinned to the origin.
export const CHART_ANCHORED_TOOLTIP_PROPS = {
  allowEscapeViewBox: { x: true, y: true },
  isAnimationActive: false,
  position: { x: 0, y: 0 },
}
